<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    
    <g>
        <path d="M9 0a7.133 7.133 0 0 0-7.125 7.125c0 4.91 4.904 9.366 6.406 10.615a1.125 1.125 0 0 0 1.438 0c1.5-1.249 6.406-5.706 6.406-10.616A7.133 7.133 0 0 0 9 0Zm0 10.875a3.75 3.75 0 1 1 0-7.5 3.75 3.75 0 0 1 0 7.5Z"
              fill="currentColor"/>
    </g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    name: {
      type: String,
      required: false,
      default: 'TwoPinMarker',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 18 18',
    },
  },
};
</script>

<style scoped>
  
</style>